import { Box, Button, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CopyIcon } from "../../../common/icons/copy.svg";
import { ReactComponent as AbsenceIcon } from "../../../common/icons/absence.svg";
import { AccessRightContext } from "../../user/AccessRightProvider";
import { EditEntry, Entry, NewEntryTalentData } from "../entriesAPI";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { NO_DRAG_SELECTOR } from "../../../app/constants";
import EntryTopInfo from "./EntryTopInfo";

interface Props {
  entry: EditEntry | Entry | null;
  showEditEntryActions?: boolean;
  handleSave?: (approve?: boolean) => void;
  handleCancel?: () => void;
  setConvertModalOpen?: (val: boolean) => void;
  setCopyModalOpen?: (entry: Entry) => void;
  newEntryTalentData?: NewEntryTalentData;
}

const Top = ({
  entry,
  showEditEntryActions,
  setConvertModalOpen,
  setCopyModalOpen,
  newEntryTalentData,
  handleCancel,
}: Props) => {
  const { t } = useTranslation();
  const { canEditEntries } = useContext(AccessRightContext);

  const canCopyEntry = !entry?.isShift && !entry?.isTargetedShift;

  const talentName = `${entry?.talentFirstName || newEntryTalentData?.firstName || ""} ${entry?.talentLastName || newEntryTalentData?.lastName || ""}`;
  const talentId = entry?.talentId || newEntryTalentData?.id || "";

  return (
    <>
      <Box
        sx={{
          display: "flex",
          height: "40px",
          width: "100%",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          cursor: "grab",
        }}
      >
        <IconButton
          className={NO_DRAG_SELECTOR}
          size="small"
          onClick={handleCancel}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      {entry && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
            rowGap: 0.5,
            cursor: "grab",
            flexWrap: "wrap",
            minHeight: "57px",
            height: "auto",
            alignContent: "center",
          }}
        >
          <EntryTopInfo
            entry={entry}
            talentName={talentName}
            talentId={talentId}
          />
          {showEditEntryActions && setConvertModalOpen && (
            <Box display="flex" gap="20px">
              {canCopyEntry && (
                <Button
                  onClick={() =>
                    entry &&
                    setCopyModalOpen &&
                    setCopyModalOpen(entry as Entry)
                  }
                  startIcon={<CopyIcon />}
                  variant="text"
                >
                  <Typography color="textSecondary" fontSize="14px">
                    {t("common:duplicate")}
                  </Typography>
                </Button>
              )}
              {canEditEntries && (
                <Button
                  onClick={() => setConvertModalOpen(true)}
                  startIcon={<AbsenceIcon />}
                  variant="text"
                >
                  <Typography color="textSecondary" fontSize="14px">
                    {t("common:makeAbsence")}
                  </Typography>
                </Button>
              )}
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

export default Top;
